import { render } from "./navbar-nav.vue?vue&type=template&id=80655d96"
import script from "./navbar-nav.vue?vue&type=script&lang=js"
export * from "./navbar-nav.vue?vue&type=script&lang=js"

import "./navbar-nav.vue?vue&type=style&index=0&id=80655d96&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__